import React, { useEffect } from "react";
import "./whyUs.css";
import video from "../../assets/whyUs.webm";
import Aos from "aos";
import "aos/dist/aos.css";

export default function WhyUs() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="s2-home">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="background-video"
      >
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Content */}
      <h2
        className="aboutcic-heading"
        data-aos="fade-left"
        data-aos-duration="1200"
        style={{ justifyContent: "center" }}
      >
        Why Choose Us
      </h2>
      <center>
        <div className="page-container">
          <div className="column" data-aos="fade-up" data-aos-duration="700">
            <h2 className="aboutcic-h1">Professionals</h2>
            <p className="aboutcic-p1">
              Our team comprises highly skilled professionals with in-depth
              knowledge of visa regulations and HR solutions, dedicated to
              providing you with personalized and efficient services.
            </p>
          </div>
          <div className="column" data-aos="fade-up" data-aos-duration="900">
            <h2 className="aboutcic-h1">Experience</h2>
            <p className="aboutcic-p1">
              With extensive experience in the industry, we have built a
              reputation for delivering top-notch solutions that cater to a
              diverse range of industries and clients.
            </p>
          </div>
          <div className="column" data-aos="fade-up" data-aos-duration="1100">
            <h2 className="aboutcic-h1">Trusted</h2>
            <p className="aboutcic-p1">
              We are committed to integrity, transparency, and excellence,
              making us the preferred choice for individuals and businesses
              seeking reliable work visa and HR services in Dubai.
            </p>
          </div>
        </div>
      </center>
    </div>
  );
}
